import { useEffect, useState, useMemo } from "react";
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { ListPageFloatingControls } from '../../components/ListPageLayout';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { displayError } from "../../helpers";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllPlants, deletePlant } from "../../services/PlantServices";
function PlantTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true); 

    const columns = useMemo(
        () => [
            {
                fieldName: 'entity_name', 
                headerName: 'Name'
            },
           
            {
                fieldName: "plant_alias",
                headerName: 'Alias'
            },
            {
                fieldName: "address_1",
                headerName: 'Address'
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
       
         
        ],
        [],);

    const onEditPlant = (plantId, event) => {
       
       navigate(`/PlantEdit/${plantId}/`);
    };
    const onDeletePlant = (plantId, event) => {
        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
            setIsLoading(true);
            deletePlant(cookies, plantId)
            .then(response => {
                console.log(`Plant Form with id ${plantId} deleted`);
                Swal.fire('Deleted Successfully!', '', 'success');
                setRefreshKey(oldKey => oldKey +1)
            })
            .catch(error => {
                setRefreshKey(oldKey => oldKey +1);
                console.log(error.response.data);
                displayError(error.response.data,'Delete Failed');
            });  
            
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(r => {

                const csvRow = {
                    entity_name: r.entity_name,
                    plant_alias: r.plant_alias,
                    address_1:r.address_1,
                    
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Group Form',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(r => ({
                entity_name: r.entity_name,
                plant_alias: r.plant_alias,
                address_1:r.address_1,
            })),
            'Plant.pdf'
        );
    };

    useEffect(() => {

        getAllPlants(cookies)
        .then( plantsList => {
            const tableData = plantsList.plant_list
            .map(r => ({
                id :r.id,
                entity_name: r.entity_name,
                plant_alias: r.plant_alias,
                address_1:r.address_1
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListPageFloatingControls
                    formLink="/Plant"
                    addNewLabel="New Plant"
                    homeLink="/Home"
                    onExportCSV={handleCSVExport}
                    onExportPDF={handlePDFExport}
                />
                <div className="container">
                    <PremiumPageHeader
                        module="ADMIN"
                        title="List of Plants"
                        subtitle="Browse and manage plant locations linked to companies."
                        modeLabel="VIEW MODE"
                    />
                </div>
                <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Group Form'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditPlant}
                            onRowDelete={onDeletePlant}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        
                        />
                </div>
                </div>
            </div>
        </div>

        
    );

}



export default PlantTable;